export const Days = {
  1: _TL_('Sunday'),
  2: _TL_('Monday'),
  3: _TL_('Tuesday'),
  4: _TL_('Wednesday'),
  5: _TL_('Thursday'),
  6: _TL_('Friday'),
  7: _TL_('Saturday'),
};

export const DayCodes = {
  Sunday: '1',
  Monday: '2',
  Tuesday: '3',
  Wednesday: '4',
  Thursday: '5',
  Friday: '6',
  Saturday: '7',
};

